import styled from 'styled-components';
import { website } from '@cld/typography';
import { globalTheme } from '@cld/component-theme';

export const Link = styled.a`
  &, &:visited {
    ${website.brandText.xs.regular};
  }
  &:hover {
    color: ${globalTheme.palette.primary};
  }
`;
